













































import { Component, Vue, Prop } from 'vue-property-decorator';
import services from '@/services';
import { getAssetUrl } from '@/utils';
import { CatalogItemFullDTO, PictureDTO, PriceDTO } from '@/api';
import { shoppingModule, thingsModule, clientsModule } from '@/store';
import IconArrowLeft from '@/assets/icons/arrow-left.svg';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';

@Component({
  name: 'catalog-item-page',
  components: { IconArrowLeft, CatalogItemPrice },
})
export default class CatalogItemPage extends Vue {
  @Prop() readonly itemId!: string;

  item: CatalogItemFullDTO | null = null;

  beforeMount() {
    this.fetchItem(parseInt(this.itemId, 10));
    if (this.client && this.client.id != null) {
      thingsModule.fetchThings(this.client.id);
    }
  }

  get client() {
    return clientsModule.model;
  }

  get maxPrice() {
    return (
      this.item
      && this.item.prices
      && this.item.prices.reduce((max, curr) => {
        const price = this.currentPrice(curr);
        const maxPrice = this.currentPrice(max);
        return price && maxPrice && price > maxPrice ? curr : max;
      })
    );
  }

  get minPrice() {
    return (
      this.item
      && this.item.prices
      && this.item.prices.reduce((min, curr) => {
        const price = this.currentPrice(curr);
        const minPrice = this.currentPrice(min);
        return price && minPrice && price < minPrice ? curr : min;
      })
    );
  }

  get shopped() {
    return shoppingModule.items;
  }

  get pictures(): PictureDTO[] {
    if (this.item && this.item.pictures) {
      if (this.item.pictures.some(item => item.size === 'SMALL')) {
        return this.item.pictures.filter(item => item.size === 'SMALL');
      }
      if (this.item.pictures.some(item => item.size === 'MEDIUM')) {
        return this.item.pictures.filter(item => item.size === 'MEDIUM');
      }
      return this.item.pictures.filter(item => item.size === 'BIG');
    }
    return [];
  }

  async fetchItem(id: number) {
    try {
      const { data } = await services
        .catalogService()
        .catalogEndpointGetItem(id);
      this.item = data;
    } catch (error) {
      // console.error(error);
      this.$notify({ title: 'Ошибка!', message: error, type: 'error' });
      this.$router.push({ name: 'shopping-catalog' });
    }
  }

  imgUrl(path: string) {
    return getAssetUrl(path);
  }

  currentPrice(item: PriceDTO) {
    return item.priceDiscount || item.price;
  }
}
